// src/components/Icon.jsx
import React from "react";

export default function Icon({ name, className = "w-5 h-5" }) {
  const map = {
    dashboard: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" className={className}>
        <path strokeWidth="1.5" d="M3 13h8V3H3v10zm10 8h8V3h-8v18zM3 21h8v-6H3v6z" />
      </svg>
    ),
    wallet: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" className={className}>
        <path strokeWidth="1.5" d="M3 7h15a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3H3V7zm0-2h12v2H3V5zm15 6h3v2h-3v-2z" />
      </svg>
    ),
    loan: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" className={className}>
        <path strokeWidth="1.5" d="M12 1v22M5 6h14a2 2 0 0 1 2 2v3H3V8a2 2 0 0 1 2-2zm-2 8h18v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3z" />
      </svg>
    ),
    history: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" className={className}>
        <path strokeWidth="1.5" d="M12 8v5l3 3" />
        <path strokeWidth="1.5" d="M21 12a9 9 0 1 1-3-6.7" />
        <path strokeWidth="1.5" d="M3 12h4M3 12a9 9 0 1 0 3-6.7" />
      </svg>
    ),
    users: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" className={className}>
        <path strokeWidth="1.5" d="M16 11a4 4 0 1 0-8 0 4 4 0 0 0 8 0z" />
        <path strokeWidth="1.5" d="M3 21a7 7 0 0 1 18 0" />
      </svg>
    ),
    report: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" className={className}>
        <path strokeWidth="1.5" d="M4 4h12l4 4v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
        <path strokeWidth="1.5" d="M14 2v6h6" />
        <path strokeWidth="1.5" d="M8 14h2v6H8zm4-4h2v10h-2zm4 6h2v4h-2z" />
      </svg>
    ),
    settings: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" className={className}>
        <path strokeWidth="1.5" d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
        <path strokeWidth="1.5" d="M19.4 15a7.97 7.97 0 0 0 .1-2 7.97 7.97 0 0 0-.1-2l2.1-1.6-2-3.4-2.5 1A7.97 7.97 0 0 0 14 3.5l-.4-2.6h-3.2L10 3.5A7.97 7.97 0 0 0 7 4l-2.5-1-2 3.4L4.6 8a7.97 7.97 0 0 0-.1 2 7.97 7.97 0 0 0 .1 2L2.5 13.6l2 3.4 2.5-1c.9.6 1.9 1 3 1.3l.4 2.6h3.2l.4-2.6c1.1-.3 2.1-.7 3-1.3l2.5 1 2-3.4L19.4 15z" />
      </svg>
    ),
    download: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" className={className}>
        <path strokeWidth="1.5" d="M12 3v12m0 0l-4-4m4 4l4-4M4 21h16" />
      </svg>
    ),
  };
  return map[name] || null;
}
